export default "__VITE_ASSET__DC5Yxf22__"